import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "@haldor/ui";
import Moment from "moment";
import sniffer from "sniffer";
import { setPageTitle } from "actions/header";
import { debounce } from "helpers/content";
import { getWithExpiration, saveWithExpiration } from "helpers/localstorage";
import ScheduleView from "./ScheduleView";
import CalenderHeader from "./Partials/CalenderHeader";
var Schedule = /*#__PURE__*/function (_Component) {
  function Schedule(props) {
    var _this;
    _classCallCheck(this, Schedule);
    _this = _callSuper(this, Schedule, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      _this.resizeEvent = window.addEventListener("resize", debounce(_this.resize, 125, false));
      _this.resize();
      _this.props.setPageTitle(_this.props.translate("Schedule"));
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      if (_this.resizeEvent != null) {
        window.removeEventListener("resize", _this.resizeEvent);
      }
    });
    _defineProperty(_this, "isLandscape", function () {
      return window.innerHeight < window.innerWidth;
    });
    _defineProperty(_this, "resize", function () {
      if (_this.props.appOrientation === "LANDSCAPE" || _this.isLandscape()) {
        _this.setState({
          mobile: false
        });
      } else {
        var width = document.body.offsetWidth;
        if (width <= _this.breakpoint) {
          if (!_this.state.mobile) {
            _this.setState({
              mobile: true
            });
          }
        } else {
          if (_this.state.mobile) {
            _this.setState({
              mobile: false
            });
          }
        }
      }
    });
    _defineProperty(_this, "setType", function (event) {
      if (_this.state.type != event.target.value) {
        localStorage.setItem("haldor-schedule-type", event.target.value);
        _this.setState({
          type: event.target.value
        });
      }
    });
    _defineProperty(_this, "setScheduleLoading", function (value) {
      _this.setState({
        scheduleLoading: value
      });
    });
    _defineProperty(_this, "goBack", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var type;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            type = _this.state.type;
            if (_this.state.mobile) {
              type = "day";
            }
            if (!(type == "month")) {
              _context.next = 7;
              break;
            }
            _context.next = 5;
            return _this.setState({
              date: Moment(_this.state.date).subtract(1, "month")
            });
          case 5:
            _context.next = 14;
            break;
          case 7:
            if (!(type == "week" || type == "work_week")) {
              _context.next = 12;
              break;
            }
            _context.next = 10;
            return _this.setState({
              date: Moment(_this.state.date).subtract(1, "week")
            });
          case 10:
            _context.next = 14;
            break;
          case 12:
            _context.next = 14;
            return _this.setState({
              date: Moment(_this.state.date).subtract(1, "day")
            });
          case 14:
            saveWithExpiration("haldor-schedule-date", _this.state.date.format());
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "goForward", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var type;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            type = _this.state.type;
            if (_this.state.mobile) {
              type = "day";
            }
            if (!(type == "month")) {
              _context2.next = 7;
              break;
            }
            _context2.next = 5;
            return _this.setState({
              date: Moment(_this.state.date).add(1, "month")
            });
          case 5:
            _context2.next = 14;
            break;
          case 7:
            if (!(type == "week" || type == "work_week")) {
              _context2.next = 12;
              break;
            }
            _context2.next = 10;
            return _this.setState({
              date: Moment(_this.state.date).add(1, "week")
            });
          case 10:
            _context2.next = 14;
            break;
          case 12:
            _context2.next = 14;
            return _this.setState({
              date: Moment(_this.state.date).add(1, "day")
            });
          case 14:
            saveWithExpiration("haldor-schedule-date", _this.state.date.format());
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    _defineProperty(_this, "goToday", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this.setState({
              date: Moment()
            });
          case 2:
            saveWithExpiration("haldor-schedule-date", _this.state.date.format());
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    _defineProperty(_this, "toggleButtons", function () {
      if (_this.state.mobile) {
        return null;
      }
      var translate = _this.props.translate;
      var type = _this.state.type;
      return /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        value: type,
        onChange: _this.setType,
        disabled: _this.state.scheduleLoading
      }, /*#__PURE__*/React.createElement("option", {
        value: "day"
      }, translate("Day")), /*#__PURE__*/React.createElement("option", {
        value: "work_week"
      }, translate("Work week")), /*#__PURE__*/React.createElement("option", {
        value: "week"
      }, translate("Week")), _this.props.activeStudent.services.advancedSchedule ? /*#__PURE__*/React.createElement("option", {
        value: "month"
      }, translate("Month")) : null, /*#__PURE__*/React.createElement("option", {
        value: "agenda"
      }, translate("Agenda"))));
    });
    _defineProperty(_this, "toggleIcon", function (flip) {
      return /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        className: flip ? "i-90" : "a-90",
        style: {
          height: "12px",
          width: "15px",
          margin: 0
        }
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })));
    });
    _this.breakpoint = 730;
    var _type = "work_week";
    var date = Moment();
    if (localStorage.getItem("haldor-schedule-type") != null) {
      _type = localStorage.getItem("haldor-schedule-type");
    }
    if (getWithExpiration("haldor-schedule-date") != null) {
      date = Moment(getWithExpiration("haldor-schedule-date"));
    }
    _this.state = {
      type: _type,
      date: date,
      scheduleLoading: false,
      mobile: document.body.offsetWidth <= _this.breakpoint
    };
    _this.resizeEvent = null;
    _this.debounced = debounce(_this.resize, 50, false);
    return _this;
  }
  _inherits(Schedule, _Component);
  return _createClass(Schedule, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.appOrientation != null && this.props.appOrientation != null && prevProps.appOrientation !== this.props.appOrientation) {
        this.resize();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isToday = Moment().isSame(this.state.date, this.state.type == "week" ? "week" : "day");
      var type = this.state.type;
      if (this.state.mobile) {
        type = "day";
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "page",
        style: {
          paddingBottom: '4rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: this.state.mobile ? "schedule section mobile" : "schedule section",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(CalenderHeader, {
        goToday: this.goToday,
        isToday: isToday,
        toggleIcon: this.toggleIcon,
        overview: this.props.overview,
        goBack: this.goBack,
        goForward: this.goForward,
        toggleButtons: this.toggleButtons,
        hasAdvancedCalendar: this.props.activeStudent.services.advancedSchedule,
        scheduleLoading: this.state.scheduleLoading
      }), /*#__PURE__*/React.createElement(ScheduleView, _extends({
        view: type,
        date: this.state.date,
        hasAdvancedCalendar: this.props.activeStudent.services.advancedSchedule,
        setScheduleLoading: this.setScheduleLoading
      }, this.props))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    activeStudent: state.User.activeStudent,
    appOrientation: state.User.appOrientation
  };
}
export default connect(mapStateToProps, {
  setPageTitle: setPageTitle
})(Schedule);